import { ReactComponent as Accounts } from "@assets/images/svg/payment.svg";
import { ReactComponent as Business } from "@assets/images/svg/business.svg";
import { ReactComponent as Driver } from "@assets/images/svg/driver.svg";
import { ReactComponent as Recruiter } from "@assets/images/svg/recruiter.svg";

import routingConstants from "@constants/constants";
import ROLES from "@constants/roles";

const localStorageData = localStorage.getItem("loggedInUser");
const getRoles = [];
JSON.parse(localStorageData)?.roles?.filter(item => {
  getRoles.push(item.RoleNames || item.RoleName);
});

const {
  PAGE_ROUTES: {
    CANDIDATE_LISTING_ROUTE,
    DAILY_BOOKING_ROUTE,
    VERIFY_BOOKING_ROUTE
  }
} = routingConstants;

const { AGENCY_USER, AGENCY_ADMIN, FINANCE_USER, CLIENT_USER } = ROLES;

const subHeaderMenu = [
  {
    name: AGENCY_ADMIN,
    icon: Driver,
    navigateTo: CANDIDATE_LISTING_ROUTE,
    disabled: !getRoles.includes(AGENCY_ADMIN)
  },
  {
    name: AGENCY_USER,
    icon: Recruiter,
    navigateTo: DAILY_BOOKING_ROUTE,
    disabled: !getRoles.includes(AGENCY_USER)
  },
  {
    name: FINANCE_USER,
    icon: Accounts,
    navigateTo: VERIFY_BOOKING_ROUTE,
    disabled: !getRoles.includes(FINANCE_USER)
  },
  {
    name: CLIENT_USER,
    icon: Business,
    navigateTo: DAILY_BOOKING_ROUTE,
    disabled: !getRoles.includes(CLIENT_USER)
  }
];

export default subHeaderMenu;
